import NavMenu from "../Navigation/NavMenu";
import styles from "./styles.module.css";
import { ReactComponent as BetaSignSVG } from "../../assets/beta-sign.svg";
import modalState from "../../state-observables/modal/ModalState";
import { createElement, useState } from "react";
import VisibleContentToggles from "../../components/oneoffs/VisibleContentToggles";
import DetailedFeedbackModal from "../../components/modals/DetailedFeedbackModal";
import { useTranslation } from 'react-i18next';
import { IoLanguage } from "react-icons/io5";

type LayoutProps = {
  children: React.ReactNode;
};

export default function Layout({ children }: LayoutProps) {
  const [isMinimized, setIsMinimized] = useState(false);
  const { i18n, t } = useTranslation();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value);
    window.applicationManager.setSelectedLocale(e.target.value);
  };

  return (
    <main
      className={[
        styles.mainContainer,
        isMinimized ? styles.minimizedMainContainer : ""
      ].join(" ")}
    >
      <header className={styles.mainHeaderContainer}>
        <span className={styles.title}>ROBOTICAL</span>

        {/* new wrapper for toggles + language */}
        <div className={styles.rightControls}>
          <VisibleContentToggles />

          <div className={styles.languageWrapper}>
            <IoLanguage className={styles.languageIcon} />
            <select
              className={styles.languageSelect}
              onChange={handleLanguageChange}
              value={i18n.language}
            >
              <option value="en">English</option>
              <option value="el">Ελληνικά</option>
              <option value="it">Italiano</option>
              <option value="nl">Nederlands</option>
            </select>
          </div>
        </div>
      </header>

      <section className={styles.mainNavigationContainer}>
        <NavMenu
          isNavMenuMinimized={isMinimized}
          setIsMinimized={setIsMinimized}
        />
      </section>

      <section className={styles.mainMainContentContainer}>
        {children}
      </section>

      <div
        className={styles.betaSignIconContainer}
        onClick={() =>
          modalState.setModal(
            createElement(DetailedFeedbackModal, {
              otherInfoObject: { from: "feedback button" }
            }),
            t("feedback_modal.title")
          )
        }
      >
        <BetaSignSVG />
      </div>
    </main>
  );
}